import "./Header.css";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useAudio } from "../AudioProvider.jsx"
import { useMoneda } from "../../context/MonedaContext.js";

// Iconos en uso
import {
  BsVolumeUpFill,
  BsFillVolumeMuteFill,
  BsCurrencyDollar,
} from "react-icons/bs";
import { MdLanguage } from "react-icons/md";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

import { useState, useEffect } from "react";

// Definimos afuera para que no se cree en cada render
const idiomas = [
  { label: "Español", code: "es" },
  { label: "English", code: "en" },
  { label: "Português", code: "pt" },
];

const monedas = ["ARS", "USD","MXN","CLP","BRL","EUR"];

const Header = () => {
  const { t, i18n } = useTranslation();

  const [idioma, setIdioma] = useState("Español"); // Para el select
  const [mostrarMenu, setMostrarMenu] = useState(false);

  useEffect(() => {
    const savedLang = localStorage.getItem("i18nextLng");
    const idiomaEncontrado = idiomas.find((i) => i.code === savedLang);
    if (savedLang && idiomaEncontrado) {
      i18n.changeLanguage(savedLang);
      setIdioma(idiomaEncontrado.label); // Mostrar "Español", "English", etc.
    }
  }, [i18n]); // <-- Solo i18n, porque idiomas ya no cambia

  const seleccionarIdioma = (nuevoIdioma) => {
    const idiomaSeleccionado = idiomas.find((i) => i.label === nuevoIdioma);
    if (idiomaSeleccionado) {
      i18n.changeLanguage(idiomaSeleccionado.code);
      localStorage.setItem("i18nextLng", idiomaSeleccionado.code); // Guardado en local storage
      setIdioma(idiomaSeleccionado.label);
      setMostrarMenu(false);
    }
  };

  const {moneda, setMoneda} = useMoneda(); // Para el select
  const [mostrarMenu2, setMostrarMenu2] = useState(false);

  const seleccionarMoneda = (nuevaMoneda) => {
    setMoneda(nuevaMoneda);
    setMostrarMenu2(false);
    console.log("Moneda seleccionada:", nuevaMoneda);
  };

  // Control de audio
  const { activo, setActivo } = useAudio();

  return (
    <header className="headerMS">
      <div className="HeaderUpMS">
        <div className="TituloHeadMS">
          <Link to="/">
            <span className="NombreP1MS">Nazaréen</span>
            <span className="NombreP2MS">El portal</span>
          </Link>
        </div>

        <div className="logoHeadMS">
          <Link to="/">
            <img src="/img/Logo.webp" alt="" />
          </Link>
        </div>

        <div className="EleccionMS">
          <div className="VolumenMS">
            <span>
              {activo ? (
                <BsVolumeUpFill color="#3f3b88" size="22px" />
              ) : (
                <BsFillVolumeMuteFill color="#3f3b88" size="22px" />
              )}
            </span>
            <label className="InterruptorMS">
              <input
                type="checkbox"
                checked={activo}
                onChange={() => setActivo((a) => !a)}
              />
              <span className="SliderMS" />
            </label>
          </div>

          <div className="idiomaMS">
            <div
              className="idiomaBotonMS"
              onClick={() => setMostrarMenu(!mostrarMenu)}
            >
              <MdLanguage color="#3f3b88" size="22px" />
              <span className="idiomaTextoMS">{idioma}</span>
              {mostrarMenu ? (
                <IoIosArrowUp size="12px" />
              ) : (
                <IoIosArrowDown size="12px" />
              )}
            </div>
            <ul className={`idiomaListaMS ${mostrarMenu ? "visible" : ""}`}>
              {idiomas.map(({ label }) => (
                <li
                  key={label}
                  onClick={() => seleccionarIdioma(label)}
                  className="idiomaOpcionMS"
                >
                  {label}
                </li>
              ))}
            </ul>
          </div>

          <div className="monedaMS">
            <div
              className="monedaBotonMS"
              onClick={() => setMostrarMenu2(!mostrarMenu2)}
            >
              <BsCurrencyDollar color="#3f3b88" size="22px" />
              <span className="monedaTextoMS">{moneda}</span>
              {mostrarMenu2 ? (
                <IoIosArrowUp size="12px" />
              ) : (
                <IoIosArrowDown size="12px" />
              )}
            </div>
            <ul className={`monedaListaMS ${mostrarMenu2 ? "visible" : ""}`}>
              {monedas.map((monedaItem) => (
                <li
                  key={monedaItem}
                  onClick={() => seleccionarMoneda(monedaItem)}
                  className="monedaOpcionMS"
                >
                  {monedaItem}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="headerCenterMS"></div>

      <div className="headerDownMS">
        <div className="hdIzqMS">
          <Link to="/terapiasHolisticas">{t("Header.headerOp1")}</Link>
          <Link to="/MasajesAyurvedicos">{t("Header.headerOp2")}</Link>
          <Link to="/vistaDetallada/13">{t("Header.headerOp3")}</Link>
        </div>
        <div className="hdDerMS">
          <Link to="/sobreMi">{t("Header.headerOp4")}</Link>
          <Link to="/faq">{t("Header.headerOp5")}</Link>
          <Link to="/sobreMi">{t("Header.headerOp6")}</Link>
        </div>
      </div>
    </header>
  );
};

export default Header;
